import { render, staticRenderFns } from "./FaqAccordian.vue?vue&type=template&id=64159074"
import script from "./FaqAccordian.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqAccordian.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports